import React, {useEffect, useState} from 'react';
import Content from "../../../components/layout/Content";
import SuppliersList from "./SuppliersList";
import {useDispatch, useSelector} from "react-redux";
import { fetchSuppliers } from "../../../action";
import {SupplierModal} from "./SupplierModal";
import {suppliersSelector} from "../../../selectors/forms";
import ErrorContainer from "../../../components/utils/ErrorContainer";

const Suppliers = () => {

    const dispatch = useDispatch();
    const suppliers = useSelector(suppliersSelector);

    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditMode, setIsEditMode] = useState(false);
    const [currentSupplier, setCurrentSupplier] = useState(null);

    useEffect(() => {
        dispatch(fetchSuppliers());
    }, [dispatch]);

    const onRefresh = () => {
        dispatch(fetchSuppliers(false, true));
    };

    const openModalForAdd = () => {
        setIsModalOpen(true);
        setIsEditMode(false);
        setCurrentSupplier(null);
    };

    const openModalForEdit = (supplier) => {
        setIsModalOpen(true);
        setIsEditMode(true);
        setCurrentSupplier(supplier);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setIsEditMode(false);
        setCurrentSupplier(null);
    };

    const renderSubHeader = () => {
        return (
            <div className="kt-subheader not-mt kt-grid__item">
                <div className="kt-container  kt-container--fluid">
                    <div className="kt-subheader__main">
                        <h3 className="kt-subheader__title">Поставщики</h3>
                        <span className="kt-subheader__separator kt-subheader__separator--v"></span>
                        <div className="kt-subheader__group" id="kt_subheader_search">
                            <span className="kt-subheader__desc" id="kt_subheader_total">
                                {suppliers.length}
                            </span>
                        </div>
                    </div>
                    <div className="kt-subheader__toolbar">
                        <button
                            onClick={openModalForAdd}
                            className="btn btn-success btn-icon-sm">
                            Добавить поставщкиа
                        </button>
                        <button onClick={onRefresh} className="btn btn-secondary btn-icon">
                            <i className="la la-refresh"></i>
                        </button>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Content>
            {renderSubHeader()}
            <ErrorContainer field='suppliers' hasCloseButton={true} style={{ margin: 25 }}/>
            <div className="kt-container kt-container--fluid kt-grid__item kt-grid__item--fluid">
                <div className="kt-grid kt-grid--desktop kt-grid--ver-desktop kt-todo">
                    <div className="kt-grid__item kt-grid__item--fluid kt-todo__content">
                        <SuppliersList suppliers={suppliers} onEdit={openModalForEdit}/>
                    </div>
                </div>
            </div>
            {isModalOpen && (
                <SupplierModal
                    onClose={closeModal}
                    isEditMode={isEditMode}
                    supplier={currentSupplier}
                />
            )}
        </Content>
    );
};

export default Suppliers